export default __webpack_public_path__ + "static/media/sponsor-banner-ms-m.ffd66041.webp";